/** Being worked on right now: a spinner. */
export const LIVE_STATUSES: ReadonlySet<string> = new Set(['dispatching', 'running', 'verifying', 'cancel_requested']);
/**
 * Waiting for its turn at the build service or the client's CI: a pulse on any pill. Only build statuses pulse; `queued`
 * is not here because other pills reuse it for a still state ("Not checked", "Builds soon"): a build's own pill
 * (`motion="build"`) pulses it through BUILD_WAITING_STATUSES.
 */
export const WAITING_STATUSES: ReadonlySet<string> = new Set(['provider_queued', 'awaiting_client']);
/** A build waiting for its turn (Hangar's queue, the build service's queue, the client's CI): its pill pulses. */
export const BUILD_WAITING_STATUSES: ReadonlySet<string> = new Set(['queued', 'pending_approval', ...WAITING_STATUSES]);

/** Which waiting set a pill uses: `status` for any pill, `build` for a build's own current status. */
export type PillMotion = 'status' | 'build';

/**
 * How a status pill moves: a spinner while worked on, a pulse while waiting, nothing for history (`still`). Reduced
 * motion stops both in CSS (styles/motion.css).
 */
export function pillMotion(status: string, motion: PillMotion = 'status', still = false): 'spin' | 'pulse' | 'none' {
  if (still) return 'none';
  if (LIVE_STATUSES.has(status)) return 'spin';
  const waiting = motion === 'build' ? BUILD_WAITING_STATUSES : WAITING_STATUSES;
  return waiting.has(status) ? 'pulse' : 'none';
}
